import React from "react";
import Navbar from "./components/Navbar";
import Generator from "./components/Generator";
import "./index.css";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Generator />
    </div>
  );
}

export default App;
